import { createReducer, on } from '@ngrx/store';
import * as fromResourcesActions from '../actions/resources.actions';
import { ResourceFirebaseResponse } from 'src/app/models/resources.model';

export interface ResourcesState {
  data: ResourceFirebaseResponse[];
  loaded: boolean;
  loading: boolean;
  error: string;
  selectedTabIndex: number;
}

export const initialState: ResourcesState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: '',
  selectedTabIndex: 0
};

export const resourcesReducer = createReducer(
  initialState,
  on(fromResourcesActions.LoadResourcesAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromResourcesActions.LoadResourcesSuccessAction, (state, { data }) => ({
    ...state,
    data,
    loaded: true,
    loading: false
  })),
  on(fromResourcesActions.LoadResourcesFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromResourcesActions.AddResourceAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromResourcesActions.AddResourceSuccessAction, (state, { resource }) => ({
    ...state,
    data: [...state.data, resource],
    loaded: true,
    loading: false
  })),
  on(fromResourcesActions.AddResourceFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromResourcesActions.DeleteResourceAction, (state) => ({
    ...state,
    loading: true
  })),
  on(
    fromResourcesActions.DeleteResourceSuccessAction,
    (state, { resource }) => ({
      ...state,
      data: state.data.filter(
        (resorceData) => resorceData.name !== resource.name
      ),
      loaded: true,
      loading: false
    })
  ),
  on(fromResourcesActions.DeleteResourceFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  }))
);
